<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="integialTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="operate" slot-scope="data">
          <span v-if="data.row.operate*1 === 0">待处理</span>
          <span style="color: #f56c6c;" v-if="data.row.operate*1 === 1">已处理返回</span>
          <span style="color: #67c23a;" v-if="data.row.operate*1 === 2">不予理会</span>
        </template>
        <template slot="wtFormTableListButtonsBefore" slot-scope="data">
          <wt-auth v-if="data.row.operate*1 === 0" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toDoJobAction(1, data.row)">补偿</el-button>
          </wt-auth>
          <wt-auth v-if="data.row.operate*1 === 0" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toDoJobAction(2, data.row)">不予处理</el-button>
          </wt-auth>
        </template>
       </wt-form-table-list>
    </wt-form-table>
    <el-dialog
      title="不予处理"
      :visible.sync="dialogVisible"
      width="30%"
      :modal="false"
      key="1"
      :before-close="handleClose">
      <div>
        <el-form v-if="dialogVisible" :model="integralValidateForm" ref="integralValidateForm" label-width="100px">
          <el-form-item label="描述内容" prop="reason"
            :rules="[
              { required: true, message: '描述内容不能为空'},
              { min: 1, max: 50, message: '描述内容长度不能超过50', trigger: 'blur' }
            ]"
          >
            <el-input type="textarea" v-model.trim="integralValidateForm.reason" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('integralValidateForm')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="补偿"
      :visible.sync="dialogMakeVisible"
      width="30%"
      :modal="false"
      key="2"
      :before-close="handleMakeClose">
      <div>
        <el-form v-if="dialogMakeVisible" :model="integralMakeValidateForm" ref="integralMakeValidateForm" label-width="100px">
          <el-form-item label="备注" prop="reason"
            :rules="[
              { required: true, message: '备注不能为空'},
              { min: 1, max: 50, message: '备注长度不能超过50', trigger: 'blur' }
            ]"
          >
            <el-input type="textarea" v-model.trim="integralMakeValidateForm.reason" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogMakeVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitMakeForm('integralMakeValidateForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_ORDERABNORMAL',
        formComponent: {
          view: { type: 'component', componentName: 'orderAbnormalView', value: 'queryOrderDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/order/orderAbnormalList' },
          delete: { type: 'default', value: '/modules/order/orderDelete' }
        },
        formInputsData: [{ name: '搜索昵称', key: 'keyWord', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [] },
          { name: '订单编号', key: 'orderNumber', value: '', type: 'text' }],
        formButtonsData: [],
        formTableData: [
          { name: '昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '订单编号', key: 'orderNumber', type: 'text' },
          { name: '下单时间', key: 'createTime', sortable: 'custom', type: 'text' },
          { name: '积分兑换', key: 'totalIntegral', type: 'text' },
          { name: '处理结果', key: 'operate', type: 'custom' }],
        formTableButtonsData: [{ name: '查看详情', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      },
      dialogVisible: false,
      integralValidateForm: {
        reason: '',
        id: ''
      },
      dialogMakeVisible: false,
      integralMakeValidateForm: {
        integral: 0,
        reason: '',
        userId: ''
      }
    }
  },
  mounted() {
    this.requestcommunityList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setorderAbnormalDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    toDoJobAction(type, row) {
      if (type === 1) {
        this.integralMakeValidateForm.id = row.id
        this.integralMakeValidateForm.integral = row.totalIntegral
        this.dialogMakeVisible = true
      }
      if (type === 2) {
        this.integralValidateForm.id = row.id
        this.dialogVisible = true
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleMakeClose() {
      this.dialogMakeVisible = false
    },
    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request({
            url: '/modules/order/orderAbnormalEdit',
            method: 'post',
            data: {
              id: this.integralValidateForm.id,
              operate: 2,
              note: this.integralValidateForm.reason
            }
          }).then(res => {
            if (res.code === '0') {
              that.$message({ message: '操作成功', type: 'success' })
              this.$refs.integialTableRef.requestList()
              that.handleClose()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitMakeForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$wtUtil.deleteConfirm(this, `您确认为该用户补偿 ${this.integralMakeValidateForm.integral} 积分吗？`).then(() => {
            request({
              url: '/modules/order/orderAbnormalEdit',
              method: 'post',
              data: {
                id: this.integralMakeValidateForm.id,
                operate: 1,
                note: this.integralMakeValidateForm.reason
              }
            }).then(res => {
              if (res.code === '0') {
                that.$message({ message: '保存成功', type: 'success' })
                this.$refs.integialTableRef.requestList()
                that.handleMakeClose()
              }
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      request({
        url: '/modules/community/communityNoPageList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.form.formInputsData[1].data = res.data
        }
      })
    }
  }
}
</script>
